/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalServiceGroupInfoRespVo
 */
export interface AdditionalServiceGroupInfoRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof AdditionalServiceGroupInfoRespVo
     */
    id?: number;
    /**
     * 附加服务组名称
     * @type {string}
     * @memberof AdditionalServiceGroupInfoRespVo
     */
    name?: string;
    /**
     * 附加服务组名称（中文）
     * @type {string}
     * @memberof AdditionalServiceGroupInfoRespVo
     */
    nameCn?: string;
    /**
     * 附加服务组编码
     * @type {string}
     * @memberof AdditionalServiceGroupInfoRespVo
     */
    code?: string;
    /**
     * 排序
     * @type {number}
     * @memberof AdditionalServiceGroupInfoRespVo
     */
    sort?: number;
    /**
     * 仓库 ID，关联仓库表
     * @type {number}
     * @memberof AdditionalServiceGroupInfoRespVo
     */
    warehouseId?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof AdditionalServiceGroupInfoRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof AdditionalServiceGroupInfoRespVo
     */
    createTime?: string;
}

/**
 * Check if a given object implements the AdditionalServiceGroupInfoRespVo interface.
 */
export function instanceOfAdditionalServiceGroupInfoRespVo(value: object): value is AdditionalServiceGroupInfoRespVo {
    return true;
}

export function AdditionalServiceGroupInfoRespVoFromJSON(json: any): AdditionalServiceGroupInfoRespVo {
    return AdditionalServiceGroupInfoRespVoFromJSONTyped(json, false);
}

export function AdditionalServiceGroupInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalServiceGroupInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'code': json['code'] == null ? undefined : json['code'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function AdditionalServiceGroupInfoRespVoToJSON(json: any): AdditionalServiceGroupInfoRespVo {
    return AdditionalServiceGroupInfoRespVoToJSONTyped(json, false);
}

export function AdditionalServiceGroupInfoRespVoToJSONTyped(value?: AdditionalServiceGroupInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'nameCn': value['nameCn'],
        'code': value['code'],
        'sort': value['sort'],
        'warehouseId': value['warehouseId'],
        'enable': value['enable'],
        'createTime': value['createTime'],
    };
}

